<template>
  <AddressFormContainer
    @transfer="(data)=>$emit('transfer',data)"
    @lockFwdBtn="(value)=>$emit('lockFwdBtn',value)"
    :income="income"
    :addresses="formData.addresses ? formData.addresses : []"
    ref="addressFormContainer"
  ></AddressFormContainer>
</template>

<script>
    import AddressFormContainer from "../components/AddressFormContainer";

    export default {
        props: ["income", 'formData'],
        components: {
            AddressFormContainer
        },
        methods: {
            transferData() {
                return this.$refs.addressFormContainer.transferData()
            }
        }
    };
</script>

